/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { columnChooserColumnchooser } from '../fn/column-chooser/column-chooser-columnchooser';
import { ColumnChooserColumnchooser$Params } from '../fn/column-chooser/column-chooser-columnchooser';

@Injectable({ providedIn: 'root' })
export class ColumnChooserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `columnChooserColumnchooser()` */
  static readonly ColumnChooserColumnchooserPath = '/api/ColumnChooser/columnchooser/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `columnChooserColumnchooser()` instead.
   *
   * This method doesn't expect any request body.
   */
  columnChooserColumnchooser$Response(params?: ColumnChooserColumnchooser$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return columnChooserColumnchooser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `columnChooserColumnchooser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  columnChooserColumnchooser(params?: ColumnChooserColumnchooser$Params, context?: HttpContext): Observable<Blob> {
    return this.columnChooserColumnchooser$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
